import React from 'react';
import PropTypes from 'prop-types';
import { ControlLabel, FormControl, FormGroup } from 'react-bootstrap';

import UploadFiles from 'components/importer/import_requests/upload_files';

import './styles/import_request_form.scss';

export default class ImportRequestForm extends React.Component {
  static propTypes = {
    database: PropTypes.shape({
      name: PropTypes.string.isRequired
    }).isRequired,
    importRequest: PropTypes.shape({
      clientNotes: PropTypes.string,
      customSourceName: PropTypes.string,
      files: PropTypes.array.isRequired,
      name: PropTypes.string,
      source: PropTypes.string
    }).isRequired,
    onAddFile: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onRemoveFile: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired
  };

  handleFormSubmit = (e) => {
    e.preventDefault();
    this.props.onSubmit();
  };

  handleFieldChange = field => (e) => {
    this.props.onChange(field, e.target.value);
  }

  handleCheckboxChange = () => {
    const { importRequest } = this.props;
    this.props.onChange('emailNotification', !importRequest.emailNotification);
  }

  render() {
    const { database, importRequest, onAddFile, onRemoveFile } = this.props;

    return (
      <form className="import-request-form" onSubmit={this.handleFormSubmit}>
        <FormGroup>
          <ControlLabel>Database</ControlLabel>
          <p>{database.name}</p>
        </FormGroup>
        {this.renderField('name', 'Import Name', { required: true })}
        <FormGroup className="mb-3" controlId="formFileLg" >
          <ControlLabel>Large file input example</ControlLabel>
          <div className="checkbox">
            <label>
              <input checked={importRequest.emailNotification}
                name="emailNotification"
                type="checkbox"
                onChange={this.handleCheckboxChange}
              />
              Notify me by email when verification is complete
            </label>
          </div>
        </FormGroup>
        <UploadFiles
          importFiles={importRequest.files}
          onAddFile={onAddFile}
          onRemoveFile={onRemoveFile}
        />
      </form>
    );
  }

  renderField(fieldName, label, controlOptions = {}) {
    const { importRequest } = this.props;

    return (
      <FormGroup>
        <ControlLabel htmlFor={fieldName}>{label}</ControlLabel>
        <FormControl
          name={fieldName}
          value={importRequest[fieldName] || ''}
          onChange={this.handleFieldChange(fieldName)}
          {...controlOptions}
        >

        </FormControl>
      </FormGroup>
    );
  }
}
